import { render, staticRenderFns } from "./taskInfoChartWidget.vue?vue&type=template&id=cfd3bac8&"
import script from "./taskInfoChartWidget.vue?vue&type=script&lang=js&"
export * from "./taskInfoChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports